 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import MM from '@/components/mm'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/title'
 import DEDICATION from '@/components/dedication'
 import GOD from '@/components/god'
 import CONTENTS from '@/components/contents'
 import PARTONE from '@/components/partone'
 import CHAPTER1 from '@/components/chapter1'
 import CHAPTER2 from '@/components/chapter2'
 import CHAPTER3 from '@/components/chapter3'
 import CHAPTER4 from '@/components/chapter4'
 import PARTTWO from '@/components/parttwo'
 import CHAPTER5 from '@/components/chapter5'
 import CHAPTER6 from '@/components/chapter6'
 import CHAPTER7 from '@/components/chapter7'
 import CHAPTER8 from '@/components/chapter8'
 import CHAPTER9 from '@/components/chapter9'
 import CHAPTER10 from '@/components/chapter10'
 import LOVE_2 from '@/components/love_2'
 import PETER from '@/components/peter'
 import BIO from '@/components/bio'
 import COPYRIGHT from '@/components/copyright'
 import AUBA from '@/components/auba'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/partone",
 			"name" : "partone",
 			"component" : PARTONE
 		},
 		{
 			"path" : "/chapter1",
 			"name" : "chapter1",
 			"component" : CHAPTER1
 		},
 		{
 			"path" : "/chapter2",
 			"name" : "chapter2",
 			"component" : CHAPTER2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js